/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React from "react";
import { Calendar } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Moment from "moment-jalaali";
import { FixNumbers } from "../../utilities/convertType";

const CalendarComponent = (props) => {
  const setDalue = (e) => {
    const isDate = `${e.year}/${e.month}/${e.day}`;
    props.setData(Moment(isDate, "jYYYY/jMM/jDD")._d);
    if (e.weekDay.index == 0) {
      props.setIndexDay(6);
    } else {
      props.setIndexDay(e.weekDay.index - 1);
    }
  };

  return (
    <div className='calendar'>
      <Calendar
        onChange={(e) => setDalue(e)}
        mapDays={({ date, today }) => {
          // if (!props.indexDay) {
          //   props.setIndexDay(today.weekDay.index - 1);
          // }
          // if (!props.data) {
          //   props.setData(Moment(date, "jYYYY/jMM/jDD")._d);
          // }
          let isDay = !props.workday.includes(date.weekDay.index);
          if (isDay) {
            return {
              disabled: true,
              style: { color: "#ccc" },
            };
          }

          let Holiday = props.holidayDate.includes(
            `${date.year}/${date.month}/${date.day}`
          );
          if (Holiday) {
            return {
              disabled: true,
              style: { color: "#ccc" },
            };
          }

          let lastYear = FixNumbers(date.year) < FixNumbers(today.year);
          if (lastYear) {
            return {
              disabled: true,
              style: { color: "#ccc" },
            };
          }

          let lastMonth =
            FixNumbers(date.year) == FixNumbers(today.year) &&
            FixNumbers(date.month) < FixNumbers(today.month);
          if (lastMonth) {
            return {
              disabled: true,
              style: { color: "#ccc" },
            };
          }

          let lastDay =
            FixNumbers(date.year) == FixNumbers(today.year) &&
            FixNumbers(date.month) == FixNumbers(today.month) &&
            FixNumbers(date.day) < FixNumbers(today.day);
          if (lastDay) {
            return {
              disabled: true,
              style: { color: "#ccc" },
            };
          }
        }}
        calendar={persian}
        locale={persian_fa}
      />
    </div>
  );
};
export default CalendarComponent;
